import React, { useState } from 'react';
import { login } from './adminApi';

export default function Login({ onSuccess }) {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            await login(password);
            onSuccess();
        } catch (err) {
            setError(err.message || 'Ошибка входа');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="admin-login">
            <form className="admin-login-card" onSubmit={submit}>
                <div className="admin-login-title">Вход в админку</div>
                <input
                    type="password"
                    className="a-input"
                    placeholder="Пароль администратора"
                    value={password}
                    autoFocus
                    onChange={(e) => setPassword(e.target.value)}
                />
                {error && <div className="a-error">{error}</div>}
                <button className="a-btn a-btn-primary" disabled={busy || !password}>
                    {busy ? 'Проверка…' : 'Войти'}
                </button>
            </form>
        </div>
    );
}
